var _excluded = ["text", "className", "shapeColor"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import classNames from "classnames";
import styles from "./UnderlineShape.module.css";
export var UnderlineShape = function UnderlineShape(_ref) {
  var text = _ref.text,
    className = _ref.className,
    shapeColor = _ref.shapeColor,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("span", _extends({
      className: classNames(styles["jds-underlineShape"], className)
    }, restProps, {
      "data-testid": "underline_shape"
    }), /*#__PURE__*/React.createElement("span", {
      className: styles["jds-underlineShape__text"],
      "data-testid": "underline_shape_text"
    }, text), /*#__PURE__*/React.createElement("svg", {
      fill: "none",
      viewBox: "0 0 80 20",
      preserveAspectRatio: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: styles["jds-underlineShape__shape"]
    }, /*#__PURE__*/React.createElement("path", {
      d: "m78.49 12.451c-9.4071-0.1542-18.784-0.7283-28.105-0.3692-13.089 0.5053-26.115 1.7142-39.184 2.5741-1.9282 0.1257-3.9034 0.1694-5.8231-0.0545-3.0445-0.35-4.5481-2.2494-4.4319-4.9086 0.12243-2.8152 2.4645-2.5104 4.8031-2.6034 10.192-0.40551 20.365-0.99897 30.544-1.5728 12.893-0.72337 25.78-1.0506 38.611 1.6983 3.0154 0.64073 4.533 2.099 3.5752 5.2345l0.0099 0.0017z",
      fill: shapeColor || "var(--mainColor)",
      "data-testid": "underline_shape_svg_path"
    })))
  );
};